import i18n from '@/langs'
const langs = process.env.VUE_APP_LANGS
const langsArr = langs ? langs.split(',') : []

const languages = [
  {
    label: 'English',
    value: 'en',
    lang: 'en',
    nvLang: 'en'
  },
  {
    label: 'ภาษาไทย',
    value: 'th',
    lang: 'th',
    nvLang: 'th'
  },
  {
    label: 'Tiếng Việt',
    value: 'vi',
    lang: 'vi',
    nvLang: 'vi'
  },
  {
    label: '日语',
    value: 'ja',
    lang: 'ja',
    nvLang: 'ja'
  },
  {
    label: '繁中',
    value: 'zh',
    lang: 'zh',
    nvLang: 'zh-TW'
  },
  {
    label: '简体中文',
    value: 'cn',
    lang: 'cn',
    nvLang: 'zh-CN'
  }
].filter(lang => {
  return langsArr.indexOf(lang.value) > -1
})

const getBrowserLanguage = () => {
  const match = languages.find(lang => {
    return lang.nvLang.indexOf(navigator.language) > -1
  })
  return match ? match.lang : null
}

// 从sessionStorage读取komoeSeaLang
const parseLangStorage = () => {
  return JSON.parse(window.sessionStorage.getItem('komoeSeaLang'))
}

// 从sessionStorage获取当前语言
const getLang = () => {
  const csLang = parseLangStorage() || getBrowserLanguage()
  if (csLang && csLang.host) {
    return csLang && csLang.host === window.location.host
      ? csLang.lang
      : i18n.locale
  } else {
    const match = languages.find(lang => {
      return lang.lang === csLang
    })
    return match ? csLang : process.env.VUE_APP_DEFAULT_LANG
  }
}

const getHtmlLang = () => {
  return languages.find(lang => {
    return lang.value === getLang()
  }).lang
}

const setLang = lang => {
  i18n.locale = lang
  
  window.sessionStorage.setItem(
    'komoeSeaLang',
    JSON.stringify(
      Object.assign(
        {
          host: window.sessionStorage.host,
          lang: getLang()
        },
        {
          host: window.location.host,
          lang: lang
        }
      )
    )
  )

  const htmlLang = getHtmlLang()
  document.documentElement.lang = htmlLang

  window.$errorLangs = i18n.messages[lang].error

  // 切换的语言和当前页面语言不同时刷新页面
  if (getLang() !== i18n.locale) {
    location.reload()
  }
}

export { setLang, getLang, getHtmlLang, languages, getBrowserLanguage }
